import React from 'react';
// Real prelander creative: close-up eye showing yellow discharge with the red
// arrow baked into the image.
export function EyeVisual() {
  return <div className="mx-auto w-full max-w-[500px]" data-id="element-26">
      <img src="https://cdn.magicpatterns.com/uploads/gLRSzVPPeB6kop4DCfAMxb/pasted-image.png" alt="Close-up of a human eye with a red arrow pointing to the yellow discharge in the inner corner" className="pointer-events-none w-full select-none rounded-md" draggable={false} data-id="element-27" />
    </div>;
}